// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1vjmt","avatar":"style_avatar__1c0kV","menuIcon":"style_menuIcon__I3ewg"};